<template>
    <v-app>
        <v-dialog
            v-model="$parent.$parent.$data[this.section]"
            persistent
            fullscreen
            hide-overlay
            transition="slide-x-reverse-transition"
            scrollable
            :content-class="isMobile"
        >
            <v-card tile>
                <v-toolbar
                    flat
                    dark
                    color="primary"
                >
                    <v-toolbar-title>{{ title }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn
                            icon
                            dark
                            @click="close()"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text>

                    <slot></slot>

                </v-card-text>

                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
import mixins from "../mixin";
export default {
    name: "Modal",
    mixins: [mixins],
    props: {
        title: String,
        width: String,
        section: String,
    },
    methods: {
        close() {
            this.$emit('close')
            if (['showCohortsDialog', 'showNewCohortDialog', 'showCohortActionsDialog'].includes(this.section)) {
                this.$parent.$parent.$data.showCohortsDialog = false
                this.$parent.$parent.$data.showNewCohortDialog = false
                this.$parent.$parent.$data.showCohortActionsDialog = false
            } else {
                this.$parent.$parent.$data[this.section] = false
            }

            if (['showNewTaskDialog'].includes(this.section)) {
                window.history.pushState({}, null, window.location.href.split('/').splice(0, 7).join('/'));
            } else {
                window.history.pushState({}, null, window.location.href.split('/').splice(0, 6).join('/'));
            }
        }
    }
}
</script>

<style lang="scss">
.v-sheet header {
    max-height: 65px !important;
}

.v-dialog__content--active {
    z-index: 99998 !important;
}

.push-10 {
    padding-left: 10% !important;
    margin-top: 55px !important;
}

.push-20 {
    padding-left: 30% !important;
    margin-top: 55px !important;
}

.push-30 {
    padding-left: 20% !important;
    margin-top: 55px !important;
}

.push-40 {
    padding-left: 40% !important;
    margin-top: 55px !important;
}

.push-50 {
    padding-left: 50% !important;
    margin-top: 55px !important;
}
</style>